export default {
  methods: {
    properCase(string) {
      var sentence = string.trim().toLowerCase().split(" ");

      for (var i = 0; i < sentence.length; i++) {
        sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
      }
      return sentence.join(" ");
    }
  },
}
